import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import { Helmet } from "react-helmet";

const toAbsoluteUrl = (value, siteUrl) => {
  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return value;

  return new URL(value, `${siteUrl}/`).toString();
};

export const Seo = ({
  title,
  description,
  siteName,
  ogImage,
  canonical,
}) => {
  const { site } = useStaticQuery(graphql`
    query SeoSiteMetadata {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `);
  const siteUrl = site.siteMetadata.siteUrl;
  const canonicalUrl = toAbsoluteUrl(canonical, siteUrl);
  const imageUrl = toAbsoluteUrl(ogImage, siteUrl);

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <meta property="og:type" content="website" />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {siteName && <meta property="og:site_name" content={siteName} />}
      {imageUrl && <meta property="og:image" content={imageUrl} />}
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {canonicalUrl && <link rel="alternate" hrefLang="en-us" href={canonicalUrl} />}
    </Helmet>
  );
};

Seo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  siteName: PropTypes.string,
  ogImage: PropTypes.string,
  canonical: PropTypes.string,
};

Seo.defaultProps = {
  title: "",
  description: "",
  siteName: "",
  ogImage: "",
  canonical: "",
};